export function YtLogoSvg({size = '24', color = '#E92C2C', ...props}) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height={size} viewBox="0 0 24 24" fill="none" {...props}>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M18.3458 5.15344C15.3425 4.94844 8.65333 4.94927 5.65417 5.15344C2.40667 5.3751 2.02417 7.33677 2 12.5001C2.02417 17.6543 2.40333 19.6243 5.65417 19.8468C8.65417 20.0509 15.3425 20.0518 18.3458 19.8468C21.5933 19.6251 21.9758 17.6634 22 12.5001C21.9758 7.34594 21.5967 5.37594 18.3458 5.15344ZM9.5 15.8334V9.16677L16.1667 12.4943L9.5 15.8334Z"
                  fill={color}/>
        </svg>
    )
}